// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './Login';
import ManningInfo from './ManningInfo';
import Opportunity from './Opportunity';
import Project from './Project'; 
import ProtectedRoute from './ProtectedRoute';
import Recruiting from './Recruiting';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/manning"
          element={<ProtectedRoute><ManningInfo /></ProtectedRoute>}
        />
        <Route
          path="/manning/:regionCode"
          element={<ProtectedRoute><ManningInfo /></ProtectedRoute>}
        />
        <Route
          path="/opportunity"
          element={<ProtectedRoute><Opportunity /></ProtectedRoute>}
        />
        <Route
          path="/opportunity/:regionCode"
          element={<ProtectedRoute><Opportunity /></ProtectedRoute>}
        />
        <Route
          path="/project"
          element={<ProtectedRoute><Project /></ProtectedRoute>}
        />
        <Route
          path="/project/:regionCode"
          element={<ProtectedRoute><Project /></ProtectedRoute>}
        />
       <Route
          path="/recruiting/:regionCode"
          element={<ProtectedRoute><Recruiting /></ProtectedRoute>}
        />
      </Routes>
    </Router>
  );
};

export default App;



